module.exports = __webpack_public_path__ + "img/icon_pen.fbbf43c.svg";